"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const VidHdCircleIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M11.359 15V9.004h-1.5v2.352H7.504V9.004H6V15h1.504v-2.418h2.355V15zm1.393-6v6h2.483C17.013 15 18 13.911 18 11.942 18 10.068 16.996 9 15.235 9zm1.503 1.226h.71c.946 0 1.503.627 1.503 1.745 0 1.188-.529 1.803-1.504 1.803h-.709z"/></g></svg>`
}, props));
VidHdCircleIcon.displayName = 'VidHdCircleIcon';
var _default = exports.default = VidHdCircleIcon;